import {useState, useEffect} from "react"
import {default as cx} from "classnames"
import {Dropdown} from "primereact/dropdown"
import {Question} from "./shared/Question"
import {wrappedGet} from "../../utilities/AxiosHelper.jsx"

export function SelectFromApiPrompt({
    orientation_id,
    questionText,
    field,
    apiPath,
    data,
    emptyError,
    handle,
    isRequired = true,
}) {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let cancelled = false
        setLoading(true)

        //  if the apiPath has variables in it
        const variables = {
            orientation_id,
        }

        const resolvedPath = apiPath.replace(/<([^>]+)>/g, (_, variableName) => variables[variableName] ?? "")

        wrappedGet(resolvedPath)
            .then((response) => {
                if (cancelled) return
                const results = response.data.results ?? []
                setOptions(results.map((item) => ({label: item.name ?? item.description, value: String(item.id)})))
            })
            .finally(() => {
                if (!cancelled) setLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [apiPath])

    return (
        <>
            <Question questionText={questionText} isRequired={isRequired} />
            <div className="w-100 py-5">
                <Dropdown
                    className={cx("w-100 p-dropdown-tall", {"border border-1 border-danger": emptyError})}
                    options={options}
                    name={field}
                    filter
                    value={data}
                    disabled={loading}
                    placeholder={loading ? "Loading..." : "Select Option"}
                    onChange={(option) => handle(option.value)}
                />
                {emptyError && isRequired && <span className="text-danger mt-n5">Selection is required</span>}
            </div>
        </>
    )
}
